import { useContext, useEffect } from "react";
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Contextone } from "./Context";
import MahuaDesi from "../images/mahuadesi.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function LivePlayer(props) {
  const { id, type_id, video_type, upcoming_type } = useParams();
  const history = useHistory();
  const countercontext = useContext(Contextone);
  const location = useLocation();
  const { url} = location.state || {};
  const host = window.location.href;

  // const vUrl = `https://${host}/player.html?file=${url}&name=${encodeURIComponent(JSON.stringify(name))}&poster=https://ottimages.b-cdn.net/playerposter.jpg&title=CHULL TV`

  // useEffect(() => {
  //   const loadQencodeScript = () => {
  //     return new Promise((resolve, reject) => {
  //       const script = document.createElement('script');
  //       script.src = "https://player-static.qencode.com/release/qencode-bootstrapper.min.js";
  //       script.onload = () => resolve();
  //       script.onerror = () => reject(new Error('Failed to load script'));
  //       document.body.appendChild(script);
  //     });
  //   };

  //   if (url) {
  //     loadQencodeScript().then(() => {
  //       const params = {
  //         licenseKey: "7b6199e3-9329-3f02-65e7-e7d674722277",
  //         playback: {
  //           autoplay: true,
  //         },
  //         videoSources: {
  //           src: `${url}`,
  //         },
  //       };

  //       if (window.qPlayer) {
  //         window.qPlayer('my_player', params, function () {
  //           const videoElement = document.querySelector('.video-js.vjs-fluid');

  //           if (videoElement) {
  //             videoElement.style.paddingTop = '45.5vw';
  //           }
  //         });
  //       } else {
  //         console.error("qPlayer is not defined");
  //       }
  //     }).catch((err) => {
  //       console.error("Failed to load Qencode player script", err);
  //     });
  //   }
  // }, [url]);

  return (
    <>
      {url  ?
        <div>
          <div className="top-left-btn">
            <button onClick={() => history.goBack()} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#000', cursor: 'pointer' }}>
              <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
            </button>
            {countercontext.isDomain === 'mahuaplay.ottsnap.in' && <img src={MahuaDesi} height="67px" />}
          </div>
          <div style={{ height: '100vh' }}>
            {/* <iframe  // bunny
              id="framePlayer"
              width="100%"
              height="99%"
              src={vUrl}
              allow="autoplay"
              allowFullScreen
            /> */}
            <iframe 
            src={url}
            width="100%" 
            height="100%" 
          ></iframe>
          </div>
        </div> :
        <div>
        {id && type_id && parseInt(video_type) === 0
          ? history.push('/')
          : history.push(`/videodetails/${type_id}/${id}/${upcoming_type}/${video_type}`)}
      </div>
      }
    </>
  );
}

export default LivePlayer;